import { useRoute } from '#imports'

export function useCurrentCategory() {
  const route = useRoute()

  return route.params.category
}
